import { Component, OnInit } from '@angular/core'
import { UntypedFormBuilder } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { CaseCreateEditComponent } from '../../../abacus/components/case-create-edit.component'
import { Field } from '../../../abacus/interfaces/field.interface'
import { ResourceDefinition } from '../../../abacus/interfaces/resource-definition.interface'
import { BreadcrumbService } from '../../../abacus/services/breadcrumb.service'
import { FlashMessageService } from '../../../abacus/services/flash-message.service'
import { ResourceService } from '../../../abacus/services/resource.service'
import { caseCreateEditTemplate } from '../../../abacus/templates/case-create-edit.template'

import { CommonModule, NgClass, NgIf } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { HasPermissionDirective } from '../../../abacus/directives/has-permission.directive'
import { CaseInputComponent } from '../../../abacus/elements/inputs/case-input/case-input.component'
import { toolUseCaseDefinition } from '../tool-use-case.definition'
import { toolUseCaseCreateEditFields } from './tool-use-case-create-edit.fields'

@Component({
    template: caseCreateEditTemplate,
    imports: [CommonModule, NgIf, NgClass, ReactiveFormsModule, FormsModule, HasPermissionDirective, CaseInputComponent],
    standalone: true
})
export class ToolUseCaseCreateEditComponent
  extends CaseCreateEditComponent
  implements OnInit
{
  definition: ResourceDefinition = toolUseCaseDefinition
  fields: Field[] = toolUseCaseCreateEditFields

  constructor(
    formBuilder: UntypedFormBuilder,
    router: Router,
    activatedRoute: ActivatedRoute,
    resourceService: ResourceService,
    breadcrumbService: BreadcrumbService,
    flashMessageService: FlashMessageService
  ) {
    super(
      formBuilder,
      router,
      breadcrumbService,
      resourceService,
      flashMessageService,
      activatedRoute
    )
  }

  ngOnInit() {
    this.initCreateEditView()
  }
}
